<template>
  <div class="change-guild-admin-dialog">
    <el-dialog :title="$t('m.change_bound_account')" :visible.sync="show" @closed="closeDialog" :close-on-click-modal="false">
      <el-form :model="ruleForm" size="small" status-icon :rules="rules" ref="ruleForm" label-position="left" label-width="180px" class="demo-ruleForm">
        <el-form-item :label="`${$t('m.agent_id_form')}`" prop="guildAdminId">
          <el-input type="text" v-model.number="ruleForm.guildAdminId"></el-input>
        </el-form-item>
        <el-form-item :label="`${$t('m.BuzzCast_verification_code')}`" prop="checkCode">
          <el-input type="text" v-model.number="ruleForm.checkCode">
            <template slot="append">
              <el-button :disabled="isChecking" @click="getCheckCode">
                {{ isChecking ?  secondsLeft + 's' : $t('m.get_vercode') }}
              </el-button>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="margin:auto;display: block;" type="primary" @click="submitForm('ruleForm')" size="small">{{ $t('m.Confirm') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { apiUpdateGuildAdmin, sendCodeForUpAppUserId } from '../../../api/guild/my-guild-detail';

export default {
  name: 'changeGuildAdminDialog',
  data() {
    return {
      show: false,
      guildAdminInfo: null,
      ruleForm: {
        guildAdminId: '',
        checkCode: '',
      },
      rules: {
        guildAdminId: [
          { required: true, trigger: "change", message: this.$t('m.no_data') },
          { type: "number", trigger: "change", message: this.$t('m.must_number'), }
        ],
        checkCode: [
          { required: true, trigger: "change", message: this.$t('m.no_data') },
        ],
      },
      isChecking: false, // 控制按钮是否可点击
      secondsLeft: 60, // 倒计时剩余秒数
    }
  },
  methods: {
    showDialog(guildAdminInfo) {
      this.guildAdminInfo = guildAdminInfo;
      this.ruleForm.guildAdminId = guildAdminInfo.guildAdminId;
      this.show = true;
    },
    closeDialog() {
      this.guildAdminInfo = null
      this.$refs.ruleForm.resetFields();
      this.show = false;
    },
    timeCountDown() {
      // 模拟发送验证码的异步操作
      console.log('发送验证码...');
      this.isChecking = true;
      // 倒计时逻辑
      let timer = setInterval(() => {
        if (this.secondsLeft <= 0) {
          // 倒计时结束，清除定时器，恢复按钮状态
          clearInterval(timer);
          this.isChecking = false;
          this.secondsLeft = 60; // 可以选择是否重置时间
        } else {
          this.secondsLeft--;
        }
      }, 1000);
    },
    getCheckCode() {

      console.log(this.ruleForm, this.guildAdminInfo);
      if (!this.isChecking && this.ruleForm.guildAdminId && this.ruleForm.guildAdminId != this.guildAdminInfo.guildAdminId) {
        if (this.ruleForm.guildAdminId > 2147483647) {
          this.$message.error(this.$t('m.id_not_exist'));
          return
        }
        sendCodeForUpAppUserId(this.ruleForm.guildAdminId).then(res => {
          let detail = res.data.data;
          console.log(detail);
          if (!detail) {
            this.$message.success(this.$t('m.send_success'));
            this.timeCountDown();
            return;
          } else if (detail.state === 2) {
            // 用户被临时冻结
            this.$message.error(this.$t('m.user_not_exist'));
            return;
          } else if (detail.state === 3) {
            this.$message.error(this.$t('m.user_frozen'));
            return;
          } else if (detail.state === 4) {
            this.$message.error(this.$t('m.apply_anchor_error'));
            return;
          } else if (detail.state === 5) {
            this.$message.error(this.$t('m.sign_anchor_error'));
            return;
          } else if (detail.state === 1) {
            this.$message.error(this.$t('m.bc_user_id_error'));
            return;
          } else if(detail.state === 0) {
            // this.guildAdminNickname = detail.nickName;
            // this.model.phoneCountry=detail.phoneCountry;

          }else {
            this.$message.error(this.$t('m.user_not_exist'));
            return;
          }
        })

      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.ruleForm.guildAdminId && this.ruleForm.guildAdminId > 2147483647) {
            this.$message.error(this.$t('m.id_not_exist'));
            return
          }
          apiUpdateGuildAdmin({
            id: this.guildAdminInfo.guildId,
            guildAdminId: this.ruleForm.guildAdminId,
            checkCode: this.ruleForm.checkCode,
            phoneCountry: this.guildAdminInfo.phoneCountry,
          }).then((res) => {
            this.show = false;
            this.$message.success(this.$t('m.account_changed_successfully'));
            this.$emit('success', this.ruleForm.guildAdminId);
            console.log(res);
          })
        }
      });
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 750px) {
  .change-guild-admin-dialog>>>.el-form-item__content{
    /* margin-left: 140px !important; */
  }
  .change-guild-admin-dialog>>>.el-input-group__append{
    border-left: 1px solid #DCDFE6;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
}
@media screen and (min-width: 767px) {
  .change-guild-admin-dialog>>>.el-form-item__content{
    /* margin-left: 160px !important; */

  }
  .change-guild-admin-dialog>>>.el-form-item{
    /* margin-left: 160px !important; */
    display: flex;
    align-items: center;
  }
  .change-guild-admin-dialog>>>.el-input-group__append{
    border-left: 1px solid #DCDFE6;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/guild/components/changeGuildAdminDialog.vue